import JsUtil from "./func/util";

const login_btn = document.querySelector(".p-btn__login");
const reward_btn = document.querySelector(".p-btn__reward");
const layer_list = [
    {
        el: '#layer-chundo1',
        buttons: '.p-btn__extand--chundo1, .p-btn__extand--chundo2, .p-btn__extand--chundo3'
    },
    {
        el: '#layer-chundo2',
        buttons: '.p-btn__extand--chundo4, .p-btn__extand--chundo5'
    },
    {
        el: '#layer-chundo3',
        buttons: '.p-btn__extand--chundo6'
    },
    {
        el: '#layer-chundo4',
        buttons: '.p-btn__extand--chundo7'
    },
    {
        el: '#layer-chundo5',
        buttons: '.p-btn__extand--chundo8'
    },
    {
        el: '#layer-drake1',
        buttons: '.p-btn__extand--drake1, .p-btn__extand--drake2, .p-btn__extand--drake3'
    },
    {
        el: '#layer-drake2',
        buttons: '.p-btn__extand--drake4, .p-btn__extand--drake5, .p-btn__extand--drake6'
    },
    {
        el: '#layer-drake3',
        buttons: '.p-btn__extand--drake7'
    },
    {
        el: '#layer-drake4',
        buttons: '.p-btn__extand--drake8, .p-btn__extand--drake9, .p-btn__extand--drake10'
    },
    {
        el: '#layer-drake5',
        buttons: '.p-btn__extand--drake11'
    },
    {
        el: '#layer-drake6',
        buttons: '.p-btn__extand--drake12, .p-btn__extand--drake13, .p-btn__extand--drake14'
    },
];

/* 각종 유틸 메소드를 가진 util 인스턴스. */
window.jsUtil = new JsUtil();

/* 레이어 */
let make_layer = layer_list.map(ele=>{
    let table = document.querySelector(ele['el']).querySelector('table');
    if(table)table.outerHTML = layer_element[ele['el']];

    return ele['buttons'] && promokit.layer(ele);
});

/* 페이지 */
let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:true,
        event:true,
        update:false,
        sns:true,
        theme:'black'
    },
    remote:{
        title:'황금빛 천명절',
        home:true,
        coupon:false,
        nshop:false,
        active:false,
        template:
        `<ul>
            <li><a href="#section-1">천명절 소원 빌기</a></li>
            <li><a href="#section-2-1">천명절 접속 보상</a></li>
            <li><a href="#section-2-2">천명절 이벤트 퀘스트</a></li>
            <li><a href="#section-3">천명절 보상 안내</a></li>
        </ul>`
    },
    caution:{
        noRule: true,
        el:'#section-caution',
    }
});

/* 로그인 */
login_btn && login_btn.addEventListener('click',function(e){
    promokit.login();
});

/* 셀렉트 박스 */
window.wish_char = promokit.select({
    el: '#wish_char',
    options: [
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
        {value: 1, label: '경국지색 / 천명절은천명천명명명'},
    ],
    placeholder: "소원 반영을 희망하는 캐릭터를 선택해 주세요"
});

/* 황금빛 보물찾기 이벤트 페이지 이동 */
reward_btn && reward_btn.addEventListener('click',function(e){
    e.preventDefault();
    location.href = 'https://bns.plaync.com/promo/bns/211110_treasure';
});



// WEBPACK FOOTER //
// ./src/js/index.js